type Unsubscribe = () => void;

abstract class IRouter<T> {
    /**
     * initialize router with routes, built as an object, where 'key' is route name and 'value' is route path
     * these 'values' should be a keys for type argument T in order to provide strongly typed routing
     * @param routesTable
     */
    public abstract initialize(routesTable: { [routeName: string]: keyof T });

    /**
     * listen to specific route and execute handler when this route hits with route parameters
     * @param route
     * @param handler
     */
    public abstract listen<K extends keyof T>(route: K, handler: (params: T[K]) => void, cleanHandler?: () => void) : Unsubscribe;

    /**
     * listen to the number of routes and execute handler when any of these routes hits
     * parameters passed into handler are not strongly typed as they may vary for different routes
     * @param routes
     * @param handler
     */
    public abstract listenAll<K extends keyof T>(routes: K[], handler: (params: T[K]) => void) : Unsubscribe;
    /**
     * listen to all routes except specific one. Useful when we want to plug in single behavior for one route but different - for other routes
     * parameters passed into handler are not strongly typed as they may vary for different routes
     * @param routes
     * @param handler
     */
    public abstract listenOthers<K extends keyof T>(routes: K, handler: () => void) : Unsubscribe;
    public abstract navigate<K extends keyof T>(route: K, params: T[K]);

    public abstract router;

    /**
     * start routing
     */
    public abstract start();
}

export { IRouter };